import React, {useEffect} from "react";

export function useDateNowMsInterval(ms: number) {
  const [now, setNow] = React.useState(() => Date.now());

  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), ms);
    return () => window.clearInterval(id);
  }, [ms]);

  return now;
}